import { useApi } from "@lending/lib/api";

/**
 * Selects one masked email option for an in-flight identity challenge, which
 * sends the verification code to the address that token resolves to server-side.
 */
function useSelectVerifiedIdentityChallengeEmailMutation() {
  const $api = useApi();

  return $api.useMutation("post", "/v2/lending/verified_identity_challenges/{uuid}/select_email/");
}

export { useSelectVerifiedIdentityChallengeEmailMutation };
